
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Head from 'next/head';
import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';
import { getHourlyWaitAverages } from '../../lib/dbFetcher';
import { DEPARTURE_HOURS, pad, formatHour, arrivalHourFor, arrivalAvgFor, byHourMap } from '../../lib/bestTimeToArrive';
async function getStaticProps() {
    let hourly = [];
    try {
        hourly = await getHourlyWaitAverages();
    }
    catch (error) {
        console.error('Error building best-time-to-arrive hub:', error);
        hourly = [];
    }
    const byHour = byHourMap(hourly);
    const rows = DEPARTURE_HOURS.map((depHour) => ({
        depHour,
        arrivalHour: arrivalHourFor(depHour),
        arrivalAvg: arrivalAvgFor(depHour, byHour)
    }));
    return { props: { rows }, revalidate: 3600 };
}
function BestTimeToArriveHub({ rows }) {
    const { t } = useTranslation('best-time-to-arrive');
    return (<div className="bg-white p-4 sm:p-6 my-auto rounded max-w-3xl mx-auto text-gray-800">
            <Head>
                <title>{t('hub_meta_title')}</title>
                <meta name="description" content={t('hub_meta_description')}/>
                <meta name="robots" content="all"/>
                <meta property="og:title" content={t('hub_meta_title')}/>
            </Head>

            <h1 className="text-2xl sm:text-3xl font-bold">{t('hub_title')}</h1>
            <p className="mt-3 text-gray-600">{t('hub_intro')}</p>

            <table className="mt-6 w-full text-left border-collapse">
                <thead>
                    <tr className="border-b">
                        <th className="py-2">{t('hub_col_flight')}</th>
                        <th className="py-2">{t('hub_col_arrive')}</th>
                        <th className="py-2">{t('hub_col_wait')}</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((r) => (<tr key={r.depHour} className="border-b">
                            <td className="py-2">
                                <Link href={`/best-time-to-arrive/${pad(r.depHour)}`} className="text-[var(--secondary)] underline">
                                    {formatHour(r.depHour)}
                                </Link>
                            </td>
                            <td className="py-2">{formatHour(r.arrivalHour)}</td>
                            <td className="py-2">
                                {r.arrivalAvg != null ? r.arrivalAvg : '-'}
                            </td>
                        </tr>))}
                </tbody>
            </table>

            <p className="mt-4 text-xs text-gray-500">{t('source_note')}</p>

            <div className="mt-6 flex flex-col gap-2">
                <Link href="/" className="text-[var(--secondary)] underline">
                    {t('cta_live')}
                </Link>
                <Link href="/security-opening-hours" className="text-[var(--secondary)] underline">
                    {t('cta_opening_hours')}
                </Link>
                <Link href="/travel-times" className="text-[var(--secondary)] underline">
                    {t('cta_weekday')}
                </Link>
            </div>
        </div>);
}
export default BestTimeToArriveHub;

    async function __Next_Translate__getStaticProps__1a1723ec701__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/best-time-to-arrive/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a1723ec701__ as getStaticProps }
  